import { ApolloError } from '@apollo/client';

export const isAbortError = (error: unknown) => {
  if (
    error instanceof ApolloError &&
    error.networkError?.name === 'AbortError'
  ) {
    return true;
  }
  if (error instanceof Error) {
    return error.name === 'AbortError';
  }

  return false;
};
